/* eslint-env es6*/
/* eslint prefer-arrow-callback: ["error", { "allowNamedFunctions": true }]*/
/* eslint object-shorthand: 0*/
import React from 'react';
import { connect } from 'react-redux';
import { MainComponentBox } from '../../../util/util.jsx';
import { Line } from 'react-chartjs';
import { getCurrencyListWrapper } from './CurrencyWrapper.js';

const mapStateToProps = (state) => ({
  getRefs: () => getCurrencyListWrapper(state),
});

const mapDispatchToProps = () => ({});

class List extends React.Component {
  render() {
    const data = this.props.getRefs();

    return (<MainComponentBox>
      {data && data.get('currency') ? data.get('currency').map((item, idx) => {
        const values = [];
        const labels = [];
        item.get('data').map((d) => {
          labels.push(d.get('date'));
          values.push(d.get('modificator'));
          return d;
        });
        return (<div id={`rates-${idx}`} key={`rates-${idx}`}>
          <h4>Rates: {item.get('origin')} => {item.get('target')}</h4>
          <Line
            data={{
              labels: labels,
              datasets: [{
                data: values,
              }],
            }}
            options={{
              title: {
                display: true,
                text: 'Chart',
              },
            }}
            width="1000"
            height="250"
          />
        </div>);
      })
        : ''}
    </MainComponentBox>);
  }
}

List.propTypes = {
  getRefs: React.PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
